<template>
  <div>
    <q-dialog
      :visible="isVisible"
      :title="title"
      width="400px"
      :innerScroll="false"
      @close="onCancel"
      :showFooter="false"
    >
      <div class="content">
        <el-table :data="tableData" :height="300" border style="width: 100%" v-loading="loading">
          <el-table-column prop="monthCode" label="店铺名称">
          </el-table-column>
          <el-table-column prop="saleNum" :label="modifyData.stroeName">
          </el-table-column>
        </el-table>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: "storeClearance",
  components: {},
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    modifyData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return this.modifyData.stroeName + "店铺清仓情况";
    },
  },
  data() {
    return {
      loading: false,
      tableData: []
    };
  },
  methods: {
    init() {
      this.loading = true
      let data = {
        ...this.modifyData
      }
      this.$q.clearanceManagement.storeGoodsSaleInfo({data: data}).then(res => {
        this.tableData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    onCancel() {
      this.isVisible = false;
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.content {
  max-height: 60vh;
  overflow-y: auto;
}

.form-input {
  width: 200px;
}

.input-number {
  >>> .el-input__inner {
    text-align: left;
  }
}

>>> .el-form .el-form-item {
  margin-bottom: 22px;
}
</style>